import { useLocation } from "react-router-dom";

import { atCourseHomePage } from "../routes/course-homepage/links";

export function useIsOnCourseHomePage() {
  const { pathname } = useLocation();
  return atCourseHomePage(pathname);
}
